export enum ObjectTypes {
  Document = 1,
  Site = 2,
  User = 3,
  Contact = 4,
  ContactType = 5,
  Country = 6,
  InvestigativeSite = 7,
  DocumentType = 8,
  Topic = 9,
  TopicField = 10,
  TopicFile = 11,
  Group = 12,
  AuditProfile = 13,
  CollaborationReview = 14,
  Domain = 15,
  RequiredDocument = 16,
  WorkFlow = 17,
  DocumentTemplate = 18,
  Amendment = 19,
  AmendmentProfile = 20,
  Folder = 21,
  CollectedDocument = 22,
  Milestone = 23,
  MilestoneHistory = 24,
  SubmissionProfile = 25,
  CRAReconciliationReport = 26,
  ESignature = 27,
  StudyProfile = 28,
  IRB = 29,
}
